module.exports = __webpack_public_path__ + "static/media/0310_Small.e709ac56.jpg";